/*
* 部门管理
* */
export const GETDEPTTREE = 'GETDEPTTREE'
export const ADDDEPT = 'ADDDEPT'
export const EDITDEPT = 'EDITDEPT'
export const DELDEPART = 'DELDEPART'
export const GETCITYS = 'GETCITYS'
/*
* 账号管理
* */
export const GETUSERPAGES = 'GETUSERPAGES'
export const USERADD = 'USERADD'
export const USERUPDATE = 'USERUPDATE'
export const USERDEL = 'USERDEL'
export const USERDISABLED = 'USERDISABLED'
export const USERRESETPWD = 'USERRESETPWD'
export const GETUSERROLE = 'GETUSERROLE'

/**
 * 角色管理
 */
export const GETTENANTROLEPAGE = 'GETTENANTROLEPAGE'
export const ADDTENANTROLE = 'ADDTENANTROLE'
export const UPDATETENANTROLE = 'UPDATETENANTROLE'
export const SELECTMENUBYROLEID = 'SELECTMENUBYROLEID'
export const SETMENUBYROLEID = 'SETMENUBYROLEID'
export const GETWAREHOUSELIST = 'GETWAREHOUSELIST'
export const SELECTDATABYROLEID = 'SELECTDATABYROLEID'
export const SETDATABYROLEID = 'SETDATABYROLEID'
export const GETMENUROLETREES = 'GETMENUROLETREES'

/**
 * 人员管理
 */
export const GETPERSONNELLIST = 'GETPERSONNELLIST'
export const DELPERSONNEL = 'DELPERSONNEL'
export const GETPERSONNEL = 'GETPERSONNEL'
export const SAVEPERSONNEL = 'SAVEPERSONNEL'
export const SAVEPERSONNELRULES = 'SAVEPERSONNELRULES'
export const GETTENANTROLEDROP = 'GETTENANTROLEDROP'

/**
 * 仓库人员管理
 */
export const GETWAREHOUSEDEPTTREE = 'GETWAREHOUSEDEPTTREE'



// WEBPACK FOOTER //
// ./src/store/systemConfig/types.js